export const EXSBITEMSCATEGORY_CREATE_RESET = 'EXSBITEMSCATEGORY_CREATE_RESET'
export const EXSBITEMSCATEGORY_CREATE_SET_CREATED = 'EXSBITEMSCATEGORY_CREATE_SET_CREATED'
export const EXSBITEMSCATEGORY_CREATE_SET_ERROR = 'EXSBITEMSCATEGORY_CREATE_SET_ERROR'
export const EXSBITEMSCATEGORY_CREATE_SET_VIOLATIONS = 'EXSBITEMSCATEGORY_CREATE_SET_VIOLATIONS'
export const EXSBITEMSCATEGORY_CREATE_TOGGLE_LOADING = 'EXSBITEMSCATEGORY_CREATE_TOGGLE_LOADING'
